//{{-- All tierboxesmodal "global" variables begin with tbm_ --}}

//{{-- ------------------------------ --}}
//{{-- Scripts to handle the popovers --}}
//{{-- ------------------------------ --}}
var popoverOpen = false;
jQuery(document).ready(function(){
    $('.economypopover').popover({
        placement: "auto", 
        trigger: "manual",
        html: true, 
        title: tbm_economy, 
        content: tbm_popover_economy
    }); 
    $('.professionalpopover').popover({
        placement: "top", 
        trigger: "manual",
        html: true, 
        title: tbm_professional, 
        content: tbm_popover_professional
    }); 
    $('.premiumpopover').popover({
        placement: "auto", 
        trigger: "manual",
        html: true, 
        title: tbm_premium, 
        content: tbm_popover_premium
    }); 
    //{{-- ------------------------------------------------------------------------- --}}
    //{{-- This group handles hiding/showing the popovers correctly                  --}}
    //{{-- A click on one of the Tier boxes will show that popover, hide all others  --}}
    //{{-- ------------------------------------------------------------------------- --}}            
    $('.economypopover, .professionalpopover, .premiumpopover').safeOn('click', function (evt){                
        evt.stopImmediatePropagation();                                                         //{{-- keep click from bubbling up --}}         
        if (popoverOpen) {
            $('.economypopover, .professionalpopover, .premiumpopover').popover('hide');        //{{-- hide all  popovers  --}}
            popoverOpen = false;
        } else {
            $(this).popover('show');
            popoverOpen = true;
        }
    });
    //{{-- A click anywhere on the document will close all popovers --}}
    $(document).on('click', function(event){
        event.stopImmediatePropagation();
        if (popoverOpen) {
            $('.economypopover, .professionalpopover, .premiumpopover').popover('hide');
            popoverOpen = false;
        }
    });

    //{{-- -------------------------------------------- --}}
    //{{-- Script to handle selecting the Tier boxes    --}}
    //{{-- -------------------------------------------- --}}
    //{{-- This is for clicking on the tier boxes - must not use stoppropagation here --}}
    $('.modaltiers').safeOn('click', function(event){                
        //{{-- First make sure there are prices: --}}
        if ($("#fileTotalT1").val() + $("#fileTotalT2").val() + $("#fileTotalT3").val()) {                
                $('.modaltiers').removeClass('bg-dark');
                $(this).addClass('bg-dark');                
        } else {
            alert(tbm_choose_cat_warn);
        }
    });
});
